import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
export default function UserOrders() {
    const navigate = useNavigate();
    const [statusFilter, setStatusFilter] = useState("All");
    const orders = [
        {
            id: "#ORD10234",
            product: "Men T-Shirt",
            date: "12 Mar 2026",
            price: 499,
            status: "Completed",
            image: "https://picsum.photos/100?1"
        },
        {
            id: "#ORD10235",
            product: "Sports Shoes",
            date: "10 Mar 2026",
            price: 1299,
            status: "In Progress",
            image: "https://picsum.photos/100?2"
        },
        {
            id: "#ORD10236",
            product: "Leather Belt",
            date: "08 Mar 2026",
            price: 299,
            status: "Pending",
            image: "https://picsum.photos/100?3"
        },
        {
            id: "#ORD10237",
            product: "Winter Jacket",
            date: "05 Mar 2026",
            price: 1599,
            status: "Completed",
            image: "https://picsum.photos/100?4"
        }
    ];
    const filteredOrders = orders.filter((o) => statusFilter === "All" || o.status === statusFilter);
    return (
        <div className="order-info">
            <button className="backhome-btn"  onClick={() => navigate("/")}>Back to Home</button>
            <h2 className="orders-title">My Orders</h2>
            <div className="orders-filter">
                <button className={statusFilter === "All" ? "active" : ""} onClick={() => setStatusFilter("All")}>All</button>
                <button className={statusFilter === "Completed" ? "active" : ""} onClick={() => setStatusFilter("Completed")}>Completed</button>
                <button className={statusFilter === "Pending" ? "active" : ""} onClick={() => setStatusFilter("Pending")}>Pending</button>
                <button className={statusFilter === "In Progress" ? "active" : ""} onClick={() => setStatusFilter("In Progress")}>In Progress</button>
            </div>
            <div className="orders-wrapper">
                {filteredOrders.map((order, index) => (
                    <div className="order-card" key={index}>
                        <div className="order-left">
                            <img src={order.image} alt="" className="order-img" />
                            <div className="order-info">
                                <h4>{order.product}</h4>
                                <p>Order ID : {order.id}</p>
                                <p>Date : {order.date}</p>
                                <p className="order-price">₹{order.price}</p>
                            </div>
                        </div>
                        <div className="order-right">
                            <span className={`order-status ${order.status.replace(" ", "").toLowerCase()}`}>{order.status}</span>
                            <button className="order-btn">View Order</button>
                            {statusFilter === "Completed" &&
                                <button className="order-btn">Feedback</button>
                            }
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}